import { z } from 'zod';
import { FEEDBACK_CATEGORIES, FEEDBACK_RELATED_ENTITY_TYPES, FEEDBACK_STATUSES, } from '../types/feedback';
const optionalTrimmedString = z
    .string()
    .optional()
    .transform((v) => (v && v.trim().length > 0 ? v.trim() : undefined));
export const feedbackSubmitInputSchema = z.object({
    category: z.enum(FEEDBACK_CATEGORIES),
    message: z.string().trim().min(10, 'Please add a bit more detail').max(2000),
    pageUrl: optionalTrimmedString,
    relatedEntityType: z.enum(FEEDBACK_RELATED_ENTITY_TYPES).optional(),
    relatedEntityId: optionalTrimmedString,
    relatedEntityName: optionalTrimmedString,
});
export const feedbackListInputSchema = z.object({
    status: z.enum(FEEDBACK_STATUSES).optional(),
    category: z.enum(FEEDBACK_CATEGORIES).optional(),
    limit: z.number().int().min(1).max(100).optional().default(20),
    offset: z.number().int().min(0).optional().default(0),
});
export const feedbackUpdateStatusInputSchema = z.object({
    id: z.string().min(1),
    status: z.enum(FEEDBACK_STATUSES),
    adminNote: z.string().max(2000).optional(),
});
export const feedbackUpdatePriorityInputSchema = z.object({
    id: z.string().min(1),
    // null clears the priority; integer 1–5 sets it.
    priority: z.number().int().min(1).max(5).nullable(),
});
